import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { LoadingController } from "@ionic/angular";
import { IframePage } from "../iframe/iframe.page";
import { Location } from "@angular/common";
import { AppRoutes } from "../../constants";
import { Router } from "@angular/router";

@Component({
  selector: "app-kajabi",
  templateUrl: "../iframe/iframe.page.html",
  styleUrls: ["../iframe/iframe.page.scss"],
})
export class KajabiPage extends IframePage {
  constructor(
    protected _store: Store<RootState>,
    protected _loadingController: LoadingController,
    private sanitizer: DomSanitizer,
    private router: Router,
    private location: Location,
  ) {
    super(_store, _loadingController);
    this.title = "Lernmodule";
    const kajabiPath = this.location.path().split(AppRoutes.kajabi).pop() || "/library";
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.wowfamily.de${kajabiPath}`);

    this.location.onUrlChange(url => {
      if (url.includes(AppRoutes.kajabi)) {
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.wowfamily.de/library");
      }
    });
  }
}
